<template>
  <vx-card
    :title="$t('class-overview.class-instruction')"
    title-color="primary"
    class="mb-base"
  >
    <template slot="actions">
      <vs-chip transparent color="primary">
        <vs-avatar
          class="bg-primary"
          :text="`${studentEnrollDetail.subject.creditCalGrade}`"
        />
        {{$t('class-overview.credit')}}
      </vs-chip>
    </template>
    <div class="p-1 mb-2">
      {{ studentEnrollDetail
        .courseOutlineRegistration
        .courseOutline
        .instruction }}
    </div>
  </vx-card>
</template>

<script>
  export default {
    name: "ClassInstruction",
    props: ['studentEnrollDetail']
  }
</script>

<style scoped>

</style>
